import { Panel } from './Panel';
import { Config } from './Config';
import { css } from '@emotion/css';
import Slider from '@mui/material/Slider'
import { Single, StateS } from '../../ProtoPanes/Single';
import { sizeName } from '../../Component';
import { getText } from '../../ProtoPanes/DefaultData';
export interface S {
    video: string;
    backgroundColor: string;
    childColor: string;
    textColor: string;
    aspect: '1/1' | '3/2' | '4/3' | '16/9' | '9/16';
    texto: boolean;
    ori: boolean;
    padding: number;
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
    xxl: number;
}
export type State = StateS & S;
export class Video extends Single<S> {
    constructor(p: any) {
        super(p);
        this.init({
            video: 'https://www.youtube.com/embed/jyQXHZrQEbQ', padding: 60,
            texto: true, ori: true, aspect: '16/9', childColor: '#f0f0f000',
            backgroundColor: '#f0f0f0', textColor: '#ffffff',
            xs: 100, sm: 100, md: 70, lg: 60, xl: 50, xxl: 50,
        });
    }
    Config = () => <Config save={this.save} setConfig={this.setData} title={this.state.title} setTitle={this.setTitle} config={this.state} />
    Panel = () => <Panel width={this.getArea()[1]} config={this.state} />
    Top = () => {
        const { texto } = this.state;
        if (texto) return <div className="container">
            <Slider className={css`&> .MuiSlider-thumb{border-radius: 0;
            border-top-left-radius: 10px;transform: rotate(45deg);}`}
                onChange={(_e: any, d: any) => this.setArea(d)} max={100} min={0}
                step={1} value={this.getArea()[1]} style={{ width: '100%' }} />
        </div>
        return <></>
    }
    setArea = (b: number) => {
        const [a] = this.getArea();
        if (b > 70) this.setState({ [a]: 100 } as any);
        else if (b > 29) this.setState({ [a]: b } as any);
        else this.setState({ [a]: 30 } as any);
    }
    getArea = () => {
        const { size, xs, sm, md, lg, xl, xxl } = this.state;
        return ((size === '570px') ? ['xs', xs] :
            (size === '780px') ? ['sm', sm] :
                (size === '990px') ? ['md', md] :
                    (size === '1080px') ? ['lg', lg] :
                        (size === '1320px') ? ['xl', xl] : ['xxl', xxl]) as [sizeName, number];
    }
    getDataSave = () => {
        const { padding, aspect, ori, texto, childColor, textColor, backgroundColor, video, xs, sm, md, lg, xl, xxl, title, html } = this.state;
        const data = JSON.stringify({});
        const props = JSON.stringify({ padding, aspect, xs, sm, md, lg, xl, xxl, ori, texto, childColor, textColor, backgroundColor, video });
        return { title, html: getText(html), data, props, type: 'video' };
    }
}